import * as LDClient from 'launchdarkly-js-client-sdk';

export default {
    install(Vue, options) {
        // eslint-disable-next-line no-param-reassign
        Vue.prototype.$launchDarkly = LDClient.initialize(options.clientId, options.context);
    },
};
